import React from 'react'
import { formatInBrazilianDatetime } from 'utils/functions'

import styles from './styles'

function DisplayThirdPartyInvestments(props) {
  const { questionData } = props
  const classes = styles()

  const buildThirdPartyInvestments = (questionInfo) => {
    const { investments_out_of_xp, has_answer } = questionInfo
    return (
      <div className={classes.answersContainer}>
        {has_answer ? (
          <React.Fragment>
            <p>
              <span>Possui investimentos fora da XP Inc: </span>
              {investments_out_of_xp.has_investments_out_of_xp ? 'sim' : 'não'}
            </p>
            {investments_out_of_xp.has_investments_out_of_xp ? (
              <React.Fragment>
                <p>
                  <span>
                    Ciente das restrições relacionadas a investimentos:{' '}
                  </span>
                  {investments_out_of_xp.aware ? 'sim' : 'não'}
                </p>
                <p>
                  <span>Ciente desde: </span>
                  {formatInBrazilianDatetime(investments_out_of_xp.confirmed_being_aware_at)}
                </p>
              </React.Fragment>
            ) : null}
          </React.Fragment>
        ) : (
          <p>A questão ainda não foi respondida</p>
        )}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Ciência das restrições de investimentos fora da XP Inc:</h3>
      {buildThirdPartyInvestments(questionData)}
    </div>
  )
}

export default DisplayThirdPartyInvestments
